import { base } from "viem/chains";
import { Token } from "./types";

export const ANYSPEND_MAINNET_BASE_URL =
  process.env.NEXT_PUBLIC_ANYSPEND_BASE_URL || "https://anyspend-mainnet.up.railway.app";
export const ANYSPEND_TESTNET_BASE_URL =
  process.env.NEXT_PUBLIC_ANYSPEND_BASE_URL || "https://anyspend-testnet.up.railway.app";

export const RELAY_ETH_ADDRESS = "0x0000000000000000000000000000000000000000";
export const RELAY_SOL_ADDRESS = "11111111111111111111111111111111";

export const RELAY_SOLANA_MAINNET_CHAIN_ID = 792703809;

export const SOLANA_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID = "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL";
export const SOLANA_TOKEN_2022_PROGRAM_ID = "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb";

export const B3_TOKEN: Token = {
  chainId: 8453,
  address: "0xb3b32f9f8827d4634fe7d973fa1034ec9fddb3b3",
  decimals: 18,
  name: "B3",
  symbol: "B3",
  metadata: {
    logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/35690.png"
  }
};

export const USDC_BASE: Token = {
  symbol: "USDC",
  chainId: base.id,
  address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
  name: "USD Coin",
  decimals: 6,
  metadata: {
    logoURI: "https://polygonscan.com/token/images/usdc_32.png"
  }
};
